window.hideVehicleRecommendations = function () {
  var wrapper = document.getElementById('vehicle-recommendations');
  var type1El = document.getElementById('vehicle-rec-type1');
  var type2El = document.getElementById('vehicle-rec-type2');

  if (type1El) type1El.style.display = 'none';
  if (type2El) type2El.style.display = 'none';
  if (wrapper) wrapper.style.display = 'none';
};

window.showVehicleRecommendations = function (connectorValue) {
  var wrapper = document.getElementById('vehicle-recommendations');
  var type1El = document.getElementById('vehicle-rec-type1');
  var type2El = document.getElementById('vehicle-rec-type2');

  window.hideVehicleRecommendations();

  if (!wrapper) {
    console.warn('vehicle-recommendations wrapper not found');
    return;
  }

  var connector = String(connectorValue || '')
    .replace(/<[^>]*>/g, ' ')
    .replace(/&nbsp;/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .toLowerCase();

  console.log('Cleaned recommendation connector:', connector);

  var isType1 = connector.indexOf('type 1') !== -1 || connector.indexOf('type1') !== -1;
  var isType2 = connector.indexOf('type 2') !== -1 || connector.indexOf('type2') !== -1;

  if (isType1 && type1El) {
    type1El.style.display = 'block';
    wrapper.style.display = 'block';
    return;
  }

  if (isType2 && type2El) {
    type2El.style.display = 'block';
    wrapper.style.display = 'block';
    return;
  }

  console.warn('No recommendation section matched connector:', connector);
};